import Rollbar from 'rollbar';
import config from './config';

const rollbar = {
    // enabled: !!process.env.NODE_ENV && process.env.NODE_ENV !== "development",
    accessToken:config.rollbarToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: config.herokuPiplineEnv,
      client: {
        javascript: {
          source_map_enabled: true,
          guess_uncaught_frames: true,
          code_version: config.herokuSlugCommit,
        },
      },
    },
  };


export default rollbar;
